var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('error-displayer',{attrs:{"message":_vm.errorMsg}}),_c('router-view',{on:{"error":_vm.onError}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }